import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-filter-popover',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './filter-popover.component.html',
    styleUrls: ['./filter-popover.component.scss']
})
export class FilterPopoverComponent implements OnInit, OnChanges {
    @Input() options: string[] = [];
    @Input() selected = new Set<string>();
    @Input() isFull = false;
    @Output() apply = new EventEmitter<Set<string>>();
    @Output() reset = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    localSelection = new Set<string>();
    // keep an ordered array copy for easy comparisons and template binding
    selectedArray: string[] = [];
    // preserve the initial selection so we can compare changes
    private initialSelection = new Set<string>();

    ngOnInit(): void {
        // clone selection so cancelling doesn't affect parent
        this.localSelection = new Set(this.selected);
        this.initialSelection = new Set(this.selected);
        this.selectedArray = Array.from(this.localSelection);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selected'] && !changes['selected'].firstChange) {
            // parent updated the applied filters (e.g. after Apply) — resync our snapshots
            this.initialSelection = new Set(this.selected || []);
            this.localSelection = new Set(this.selected || []);
            this.selectedArray = Array.from(this.localSelection);
        }
    }

    get hasSelection(): boolean {
        return this.localSelection != null && this.localSelection.size > 0;
    }

    // actionsEnabled when there's any selection OR when selection differs from initial
    get actionsEnabled(): boolean {
        if (this.localSelection == null) return false;
        if (this.localSelection.size > 0) return true;
        // if localSelection is empty but initial had items, actions should be enabled (user cleared selection)
        return this.initialSelection != null && this.initialSelection.size > 0;
    }

    toggle(opt: string) {
        if (this.localSelection.has(opt)) this.localSelection.delete(opt);
        else this.localSelection.add(opt);
        // keep array in sync for any template bindings that need it
        this.selectedArray = Array.from(this.localSelection);
    }

    onApply() {
        this.apply.emit(new Set(this.localSelection));
    }

    onReset() {
        this.localSelection.clear();
        this.reset.emit();
        this.selectedArray = [];
    }

    onCancel() {
        this.cancel.emit();
    }
}
